class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: 'cart-items',
        selector: 'cart-items .js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'cart-footer',
        section: 'main-cart-footer',
        selector: '#cart-footer',
      },
    ];
  }

updateUI(parsedState) {
  if (!parsedState.sections) {
    this.classList.toggle('is-empty', parsedState.item_count === 0);

    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) {
      mainCartItems.innerHTML = '<p>Tu carrito está vacío.</p>';
    }

    const generateQuoteButton = document.getElementById('generate-quote-button');
    if (generateQuoteButton) {
      generateQuoteButton.disabled = true;
    }

    return;
  }

  const sections = this.getSectionsToRender();
  console.log('Secciones recibidas:', Object.keys(parsedState.sections));
  
  console.log('Contenido de main-cart-footer:', parsedState.sections['main-cart-footer']);

  sections.forEach(({ id, section, selector }) => {
    const elementToReplace = document.getElementById(id)?.querySelector(selector) || document.getElementById(id);
    const html = parsedState.sections[section];
  
    if (elementToReplace && html) {
      const sectionHTML = new DOMParser().parseFromString(html, 'text/html');
      const newContent = sectionHTML.querySelector(selector) || sectionHTML.body.firstElementChild;
  
      if (newContent) {
        elementToReplace.innerHTML = newContent.innerHTML;
      }
    } else {
      console.warn(`No se pudo reemplazar la sección: ${id}`);
    }
  });

  const cartDrawerWrapper = document.querySelector('cart-drawer');
  const cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

  const generateQuoteButton = document.getElementById('generate-quote-button');
  if (generateQuoteButton) {
    generateQuoteButton.disabled = parsedState.item_count === 0;
  }

  if (parsedState.item_count === 0 && cartDrawerWrapper) {
    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
  }
}

  updateQuantity(line, quantity, name, variantId) {
    if (isNaN(line) || isNaN(quantity) || line < 1 || quantity < 0) {
      console.error('Error: Invalid line or quantity');
      return;
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    console.log('Cuerpo de la solicitud:', body);
    console.log("Solicitando secciones:", this.getSectionsToRender().map(s => s.section));
    console.log("Cuerpo de la solicitud:", body);
    fetch(`${routes.cart_change_url}`, { 
      ...fetchConfig(),
      body,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error en la solicitud del carrito');
        }
        return response.text();
      })
      .then((state) => {
        console.log('Respuesta cruda del servidor:', state);
        const parsedState = JSON.parse(state);
        console.log('Estado parseado:', parsedState);
        console.log('Cantidad de ítems en carrito:', parsedState.item_count);
      
        if (parsedState.item_count === 0) {
          console.log('El carrito está vacío según el backend');
        }
      
        this.updateUI(parsedState);
      
        if (parsedState.errors) {
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
      
        this.disableLoading(line);
      
        this.updateCartVisual();
      })
      .catch((error) => {
        console.error('Error al actualizar el carrito:', error);
        this.updateLiveRegions(line, { error: 'Hubo un problema al actualizar el carrito.' });
        this.disableLoading(line);
      });
  }

  updateCartVisual() {
    
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const cartItemsSection = html.querySelector('#main-cart-items');

        const targetElement = document.querySelector('#main-cart-items');
        if (targetElement && cartItemsSection) {
          targetElement.innerHTML = cartItemsSection.innerHTML;
        }
 
        if (cartItemsSection.innerHTML.trim() === '') {
          document.querySelector('.cart__footer').classList.add('is-empty');
        } else {
          document.querySelector('.cart__footer').classList.remove('is-empty');
        }
      })
      .catch((error) => {
        console.error('Error al actualizar el carrito:', error);
      });
  }

  updateLiveRegions(line, errors) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = errors;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
